import { render } from "./pl5wei.vue?vue&type=template&id=1ca04c4a&scoped=true"
import script from "./pl5wei.vue?vue&type=script&lang=js"
export * from "./pl5wei.vue?vue&type=script&lang=js"

import "./pl5wei.vue?vue&type=style&index=0&id=1ca04c4a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca04c4a"]])

export default __exports__